import { ClaimTypesEnum } from '../enums/claim-types.enum';
import { UserTypes } from '../enums/user-type.enum';

/**
 * Minimal shape shared by every `Claim` type in the app (`models/claims.model`,
 * `synlab-access-ui-components/core`), so callers can pass whichever they hold.
 */
type ClaimLike = { claimType: string; claimValue: string };

/**
 * Every `user_type` value the user holds.
 *
 * `user_type` is a multi-valued claim — a user can carry several — so this
 * collects all matching claims rather than just the first.
 */
export function getUserTypes(claims: readonly ClaimLike[] | null | undefined): string[] {
  return (claims ?? [])
    .filter(claim => claim.claimType === ClaimTypesEnum.USER_TYPE)
    .map(claim => claim.claimValue);
}

/**
 * True when the user holds at least one of `userTypes`.
 *
 * Use this for per-user-type UI policies so the claim plumbing lives in one
 * place: declare the policy as a `UserTypes[]` constant next to the feature and
 * pass it in.
 */
export function hasAnyUserType(
  claims: readonly ClaimLike[] | null | undefined,
  userTypes: readonly UserTypes[]
): boolean {
  const heldUserTypes = getUserTypes(claims);
  return userTypes.some(userType => heldUserTypes.includes(userType));
}
